import React from 'react';
import './WebDevelopmentPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

function WebDevelopmentPage() {
  return (
    <div className="webdev-page">
      <Header />
      
      <section className="webdev-hero">
        <div className="webdev-hero-wrapper">
          <div className="webdev-hero-image-left">
            <img src="/slide1S.png" alt="Viviworks.AI" className="webdev-hero-decorative-left" />
          </div>

          <div className="webdev-hero-container">
            <h1 className="webdev-hero-title">
              <span className="webdev-hero-highlight">Création</span> de sites vitrines, e-commerce et web apps
            </h1>
            <p className="webdev-hero-text">
              Nous développons des sites web sur mesure qui allient esthétique, performance et stratégie. 
              Grâce à l'IA, nos sites web deviennent intelligents. Chaque interaction est analysée pour s'améliorer, s'adapter et offrir une expérience utilisateur optimale. Des modules de chatbot intelligent, des recommandations personnalisées et des interfaces qui s'adaptent à chaque visiteur.
            </p>
            <p className="webdev-hero-text">
              Nos solutions offrent non seulement design moderne, mais résultats et d'impact mesurés grâce à des indicateurs précis, intégrant votre stratégie digitale et répondant aux attentes de vos clients.
            </p>
            <button className="webdev-hero-button">Découvrir nos services</button>
          </div>
        </div>
      </section>

      <section className="webdev-automation">
        <div className="webdev-automation-wrapper">
          <div className="webdev-automation-container">
            <h2 className="webdev-automation-title">
              <span className="webdev-automation-highlight">Automatisation</span> et personnalisation via IA
            </h2>
            <p className="webdev-automation-text">
              L'intelligence artificielle est au cœur de notre approche du développement web.
            </p>
            <p className="webdev-automation-text">Nous intégrons des :</p>
            <ul className="webdev-automation-list">
              <li>Chatbots intelligents pour répondre aux questions de vos visiteurs 24/7</li>
              <li>Systèmes de recommandations personnalisées pour augmenter vos ventes</li>
              <li>Analyse UX automatisée pour comprendre et améliorer le comportement des visiteurs</li>
              <li>Grâce à ces technologies, votre site devient un outil vivant, capable d'apprendre, de s'adapter et d'évoluer au fil du temps. Tout ce dont nous avons besoin, c'est de votre vision : nous nous occupons de la rendre intelligente et performante.</li>
            </ul>
            <p className="webdev-automation-text">
              Notre objectif : transformer votre site en une véritable expérience utilisateur intelligente, fluide et engageante.
            </p>
            <button className="webdev-automation-button">En savoir plus</button>
          </div>

          <div className="webdev-automation-image-right">
            <img src="/slide1Q.png" alt="Viviworks.AI" className="webdev-automation-decorative-right" />
          </div>
        </div>
      </section>

      <section className="webdev-technologies">
        <div className="webdev-technologies-container">
          <h2 className="webdev-technologies-title">
            <span className="webdev-technologies-highlight">Technologies</span> utilisées
          </h2>
          <p className="webdev-technologies-intro">
            Notre équipe maîtrise un large éventail de technologies modernes et performantes
          </p>

          <div className="webdev-technologies-grid">
            <div className="webdev-tech-logo">
              <img src="/js.png" alt="JavaScript" />
            </div>
            <div className="webdev-tech-logo">
              <img src="/css-3.png" alt="CSS3" />
            </div>
            <div className="webdev-tech-logo">
              <img src="/php.png" alt="PHP" />
            </div>
            <div className="webdev-tech-logo">
              <img src="/icons8-nœud-js-32.png" alt="Node.js" />
            </div>
            <div className="webdev-tech-logo">
              <img src="/icons8-logo-de-printemps-48.png" alt="Spring" />
            </div>
            <div className="webdev-tech-logo">
              <img src="/icons8-firebase-48.png" alt="Firebase" />
            </div>
            <div className="webdev-tech-logo">
              <img src="/icons8-chatgpt-50.png" alt="ChatGPT" />
            </div>
            <div className="webdev-tech-logo">
              <img src="/google-ai-gemini91216.logowik.com.webp" alt="Google Gemini AI" />
            </div>
          </div>

          <p className="webdev-technologies-description">
            Nous combinons ces technologies avec nos algorithmes d'intelligence artificielle pour garantir un développement web à la fois puissant, évolutif et aligné avec les tendances du web de demain.
          </p>
        </div>
      </section>

      <section className="webdev-cta">
        <div className="webdev-cta-wrapper">
          <div className="webdev-cta-image-left">
            <img src="/slide1S.png" alt="Viviworks.AI" className="webdev-cta-decorative-left" />
          </div>

          <div className="webdev-cta-container">
            <h2 className="webdev-cta-title">
              Votre site, propulsé par <span className="webdev-cta-highlight">l'intelligence artificielle</span>
            </h2>
            <p className="webdev-cta-text">
              Avec Viviworks.AI, votre site ne se limite pas à être une vitrine. Il devient une expérience intelligente qui apprend de ses visiteurs et évolue avec vos activités.
            </p>
            <p className="webdev-cta-text">
              Contactez-nous pour un projet et découvrez comment l'IA peut transformer votre présence digitale en véritable moteur de croissance.
            </p>
            <button className="webdev-cta-button">Contactez-nous</button>
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default WebDevelopmentPage;

